import React from 'react';
import { Flex, Modal , Typography } from 'antd';
import iartisanatLogo from '../../images/logos/iartisanat.png';

const { Text } = Typography;

const IArtisanatModal = ({setIsModalOpen, isModalOpen}) => {

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Flex align='center' justify='center'>
      <Modal
        title="Developer"
        centered
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%',
        }}
      >
        <Text>
          <br />
          During my Master 1 internship, I focused on developing solutions to automate and improve business processes.<br />
          My responsibilities included:
          <br />
          <br />
          • <strong>Developing an automated prospecting system</strong> targeting 20,000 artisans across France using Selenium, Scikit-learn, and Puppeteer.<br />
          • <strong>Creating a voice assistant</strong> capable of generating quotes and work estimates through natural conversation using Google Cloud Speech API and the OpenAI API, replacing traditional form-filling.<br />
          • <strong>Building a website generator</strong> for businesses in the iArtisanat network based on a template using Vite.js, Tailwind CSS, and React.js, enabling rapid deployment of artisan websites.<br />
          • Standardizing the company's visual identity by <strong>developing a Python-based logo generator</strong> that adapts to company colors and various slogans.<br />
          <br />
          <br />
        </Text>
        <Flex justify='end'><img src={iartisanatLogo} alt='iartisanat-logo' width='200px' /></Flex>
      </Modal>
    </Flex>
  );
};

export default IArtisanatModal;